// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1I_t-","clinicsSelect":"TableHeading_clinicsSelect__1dWi2"};